import React from "react";
import { Dropdown } from "react-bootstrap";
import cx from "classnames";
import _ from "lodash";
import styles from "./styles.module.scss";
import Text from "src/components/text";
import Tooltip from "src/components/tooltip";
import Truncate from "src/components/truncate";

class CustomFieldDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: props.fields,
      selected: props.selected,
    };
  }

  removeCustomField(item) {
    this.props.removeCustomField(item);
  }

  render() {
    return (
      <div className={styles.fieldDropdown}>
        <div className={styles.field}>
          <Dropdown key={this.state.selected.id} disabled={true}>
            <Dropdown.Toggle className={styles.dropdown}>
                <Tooltip content={this.state.selected.name}>
                  <span>
                  <Truncate  className={styles.text}  width={170 } >     
                    {this.state.selected.name}
                  </Truncate>
                  </span>
                </Tooltip>
            </Dropdown.Toggle>
          </Dropdown>
        </div>

       {_.get(this.state,"selected.options",[]).length > 0 && <div className={styles.listValues}>
          {this.state.selected && (
            <Dropdown rootCloseEvent="click">
              <Dropdown.Toggle className={styles.dropdown}>
                <span className={styles.text}> VIEW LIST VALUES </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.dropdownMenu}>
                <div className={styles.options}>
                  {this.state.selected.options &&
                    this.state.selected.options.map((item, index) => {
                      return (
                        <Dropdown.Item
                          key={item.value}
                          eventKey={item}
                          className={styles.item}
                        >
                          {item.value}
                        </Dropdown.Item>
                      );
                    })}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>}

        <div
          className={styles.remove}
          onClick={() => this.removeCustomField(this.state.selected)}
        >
          <span className={styles.text}> REMOVE </span>
        </div>
      </div>
    );
  }
}

export default CustomFieldDropdown;
